import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Loader2 } from "lucide-react";

export default function ProtectedRoute({ children, staff = false }) {
  const { user } = useAuth();
  const location = useLocation();

  if (user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center cyber-grid" data-testid="auth-loading">
        <Loader2 className="w-8 h-8 animate-spin text-primary-c" />
      </div>
    );
  }
  if (user === false) {
    return <Navigate to={`/login?next=${encodeURIComponent(location.pathname + location.search)}`} replace />;
  }
  if (staff && user.account_type === "player" && !["admin", "super_admin"].includes(user.role)) {
    return <Navigate to="/dashboard" replace />;
  }
  // Umpire accounts have no player/organizer role — send them straight to the console.
  if (user.role === "umpire") {
    return location.pathname.startsWith("/umpire") ? children : <Navigate to="/umpire/score" replace />;
  }
  // Google users who haven't chosen an account type must finish onboarding first.
  if (user.account_type === null && location.pathname !== "/complete-profile") {
    return <Navigate to="/complete-profile" replace />;
  }
  return children;
}
